var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-name g-flex g-flex-sb  g-table-header g-pt-10 g-pb-10 table-computed__ele"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.name)+"\n    "),_vm._t("tip")],2),_vm._v(" "),_c('div',{staticClass:"g-flex"},[_c('rich-text'),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b8f872","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-name/index.vue
// module id = null
// module chunks = 